import { mockDelay, mockHttpError } from './withMockFallback';

/**
 * Mock политики прав на аналитику (Part 4, раздел 6.9). DTO повторяет ТЗ 1:1.
 *
 * Два режима независимы: правила и зоны камеры могут редактироваться по разным
 * правилам, и UI обязан это выдерживать.
 */

const ALLOWED_MODES = ['admin_only', 'client_with_admin_approval', 'client_and_admin'];

const createPolicy = (cameraId) => ({
  camera_id: Number(cameraId),
  rules_edit_mode: 'admin_only',
  zones_edit_mode: 'client_with_admin_approval',
  version: 2,
  updated_at: '2026-09-07T12:00:00Z',
});

const store = new Map();

export const getPolicyState = (cameraId) => {
  const key = String(cameraId);
  if (!store.has(key)) store.set(key, createPolicy(cameraId));
  return store.get(key);
};

export const getAnalyticsPolicyMock = (cameraId) => mockDelay({ ...getPolicyState(cameraId) });

export const updateAnalyticsPolicyMock = (cameraId, payload = {}) => {
  const state = getPolicyState(cameraId);

  if (payload.expected_version !== state.version) {
    return Promise.reject(mockHttpError(409, {
      detail: 'analytics_policy_version_conflict',
      current_version: state.version,
    }));
  }

  const invalid = ['rules_edit_mode', 'zones_edit_mode']
    .filter((field) => payload[field] !== undefined && !ALLOWED_MODES.includes(payload[field]));

  if (invalid.length > 0) {
    return Promise.reject(mockHttpError(422, {
      detail: [{ loc: ['body', invalid[0]], msg: 'unknown edit mode' }],
    }));
  }

  state.rules_edit_mode = payload.rules_edit_mode ?? state.rules_edit_mode;
  state.zones_edit_mode = payload.zones_edit_mode ?? state.zones_edit_mode;
  state.version += 1;
  state.updated_at = new Date().toISOString();

  return mockDelay({ ...state });
};

/** Только для тестов. */
export const resetAnalyticsPolicyMock = () => store.clear();
